import React from 'react';

import socialFactorLogo from '@/lib/assets/social_factor_logo.png';
import getIsSpecialUICondition from '@/lib/helpers/getIsSpecialUICondition';
import logo from '@/pages/auth/login/logo.webp';

function Logo({ isNotFoundPage }: { isNotFoundPage?: boolean }) {
	const isSpecialUICondition = getIsSpecialUICondition();

	return (
		<img
			src={isSpecialUICondition ? socialFactorLogo : logo}
			alt={isSpecialUICondition ? 'Social Factor logo' : 'Social Voice logo'}
			style={isSpecialUICondition && isNotFoundPage ? { maxWidth: '30%' } : {}}
		/>
	);
}

export default React.memo(Logo);
